import type { FC } from "react";
import React from "react";

import clsx from "clsx";

import { Btn } from "./style";

import type { BaseButtonProps } from "../index";
import { ButtonSizes } from "../index";

interface DarkButtonProps extends Omit<BaseButtonProps, "type"> {
	type: "submit" | "button";
}

const DarkButton: FC<DarkButtonProps> = ({
	children,
	className = "",
	loading,
	disabled,
	startIcon,
	endIcon,
	size,
	...rest
}) => (
	<Btn className={clsx(className, `size_${size}`)} disabled={loading || disabled} {...rest}>
		{!!startIcon && <div className="shrink-0">{startIcon}</div>}
		{typeof children === "string" ? (
			<p
				className={clsx(
					"font-medium text-red-300",
					(size === ButtonSizes.XS || size === ButtonSizes.SM) && "text-xs leading-4",
					size === ButtonSizes.MD && "text-base leading-5"
				)}
			>
				{children}
			</p>
		) : (
			children
		)}
		{!!endIcon && <div className="shrink-0">{endIcon}</div>}
	</Btn>
);

export default DarkButton;
